import type { PrimaryLink } from "$lib/features/_other/primaryLink.type";
import { type CityFeature } from "$lib/features/cityFeature/cityFeature.type";
import { CITY_FEATURE_TYPES_WITH_STORY } from "$lib/features/cityFeature/cityFeatureType.enum";
import type { TimelineEvent } from "$lib/features/timelineEvent/timelineEvent.type";

export interface HiddenGem {
	story: string;
	durationMinutes: number;
	events: TimelineEvent[];
	primary: PrimaryLink | null;
	feature: CityFeature;
}

/**
 * Checks if the hidden gem should display the story and events or not, as pages like attraction already have stories and events, so no point repeating the same thing
 * @param item the hidden gem to check
 */
export function shouldDisplayStoryElements(item: HiddenGem): boolean {
	const hasNoPrimaryLink = item.primary === null;
	const primaryLinkHasStoryAndEvents = item.primary && CITY_FEATURE_TYPES_WITH_STORY.includes(item.primary.type);
	return hasNoPrimaryLink || !primaryLinkHasStoryAndEvents;
}